import {Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'label-input-pair',
    templateUrl: './label-input-pair.component.html',
    styleUrls: ['./label-input-pair.component.css']
})
export class LabelInputPairWidget {
	@Input() label:string;
	private  _required:any;
	private  _disabled:any;
	public invalid: boolean = false;
	public errorMessage: string = "";
	@Input() model:any;
	@Input() type:string;
	@Input() additionalInfo:string;
	@Input() icon:string;
	@Input() large:boolean;
	@Input() placeholder:string;
	@Input() pattern:string;
	@Input() helpMessage;
	@Input() patternErrorMessage: string = "";
	@Input() verified: boolean = false;
	@Input() reVerifyShow: boolean = false;

	@Output() modelChange: EventEmitter<any> = new EventEmitter();
	@Output() focused: EventEmitter<any> = new EventEmitter();
	@Output() reVerify: EventEmitter<any> = new EventEmitter();

	@Input()
	set required(required: string) {
		this._required = required === "" || required === "true";

	}

	get required(): string { return this._required; }

	@Input()
	set disabled(disabled: string) {
		this._disabled = disabled === "" || disabled === "true";

	}

	get disabled(): string { return this._disabled; }


	onChanges(newValue) {
		this.model = newValue;
		this.validate();
		this.modelChange.emit(newValue);
	}

	onFocus(focusEv) {
		this.focused.emit(focusEv);
	}

	public validate() {
		this.errorMessage = "";
		if (this.pattern && !this.model.match(new RegExp(this.pattern))) {
			this.errorMessage = this.patternErrorMessage;
			this.invalid = true;
			return;
		}
		if (this.required && (this.model == null || this.model === "")) {
			this.errorMessage = "PropertyRequired";
			this.invalid = true;
			return;
		}

		this.invalid = false;
	}

	public reVerifyClick(e) {
		this.reVerify.emit(e);
	}
}
